import { render, staticRenderFns } from "./InspectionNG.vue?vue&type=template&id=1bb09230&scoped=true"
import script from "./InspectionNG.vue?vue&type=script&lang=js"
export * from "./InspectionNG.vue?vue&type=script&lang=js"
import style0 from "./InspectionNG.vue?vue&type=style&index=0&id=1bb09230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb09230",
  null
  
)

export default component.exports